import { SimpleToggle } from "components/Form/components/Switch/Switch";
import Tooltip from "components/Tooltip/Tooltip";
import "./ChildrenScopeToggle.scss";

export interface ChildrenViewModeToggleProps {
    isTreeView: boolean;
    setIsTreeView: (isTreeView: boolean) => void;
}

/**
 * Toggle for the execution "Children" tab: switch between the flat descendant list
 * and an expandable parent/child tree (nodes indented by spawn depth, toggleable).
 * Styled like the sibling "All descendants" switch.
 */
export const ChildrenViewModeToggle = ({
    isTreeView,
    setIsTreeView,
}: ChildrenViewModeToggleProps) => (
    <Tooltip overlay="Show the descendant executions as an expandable parent/child tree instead of a flat list">
        <div className="childrenScopeToggle">
            <SimpleToggle
                identifier="children_tree_view"
                size="md"
                value={isTreeView}
                additionalAttributes={{
                    onChange: (checked: boolean) => setIsTreeView(checked),
                }}
            />
            <span
                className="childrenScopeToggle__label"
                onClick={() => setIsTreeView(!isTreeView)}
            >
                Tree view
            </span>
        </div>
    </Tooltip>
);
